import { SelectProps } from "antd";
import useAuth from "../../hooks/useAuth";
import { OfficeProperties } from "../../types/office.type";
import SelectAllOffice from "./SelectAllOffice";
import SelectMyOffice from "./SelectMyOffice";

interface FilterOfficeProps extends SelectProps {
	value?: string;
	onChange?: (value: string) => void;
	excludeOfficeId?: string;
	officeList?: OfficeProperties[];
	setOfficeList?: React.Dispatch<React.SetStateAction<OfficeProperties[]>>;
	showOfficeCode?: boolean;
}
const SelectOffice: React.FC<FilterOfficeProps> = ({ officeList, setOfficeList, ...rest }) => {
	const { isFO, isAdminHQPlus, isHQFinance, officeId, isAgent } = useAuth();

	return isFO ? (
		<SelectMyOffice
			isFilter={false}
			{...rest}
		/>
	) : isAdminHQPlus || isHQFinance ? (
		<SelectAllOffice
			allowClear
			officeList={officeList}
			setOfficeList={setOfficeList}
			{...rest}
		/>
	) : (
		<SelectMyOffice
			isFilter={false}
			{...rest}
			disabled
		/>
	);
};
export default SelectOffice;
